<template>
  <section class="campaign">
    <Header :user="user" />
    <main class="main">
      <div class="row mt-2 p-2">
        <div class="col-md-12">
          <div class="content-chart">
            <div class="card border border-white">
              <div>
                <div class="contenedor animated fadeIn faster p-1">
                  <!-- <MeetingByMonth /> -->
                  <div class="card p-1">
                    <h4 class="ml-3">Activity</h4>
                    <ViewActivity ></ViewActivity>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import MeetingByMonth from "@/components/Dashboard/MeetingByMonth.vue";
import ViewActivity from "@/components/Activity/ViewActivity.vue";


export default {
  // created() {
  //   this.changeHeaderTab({ tab: "BILLING" });
  // },

  components: {
    Header,
    ViewActivity,
    MeetingByMonth
  },

  computed: {
    ...mapState({
      headerTab: state => state.header.tab
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },

  mounted(){
    this.udpdateHeader('activity_user');
  },

  methods: {
      ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),
     ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },
  }
};
</script>
